import React, { useRef, useState } from 'react';
import styled from 'styled-components';
import { useParams } from 'react-router-dom';
import { Checkbox } from '/imports/ui/Checkbox';
import { ModelFormPage } from '/imports/ui/ModelFormPage';
import { Page } from '/imports/ui/Page';
import { modelClass, PrimeRate } from '/imports/api/primeRates';
import { NumberInput } from '/imports/ui/NumberInput';
import { DateInput } from '/imports/ui/DateInput';

const PrimeRatePageStyled = styled(Page)`
`;

/** Super-user form page for creating/editing a prime rate. */
export const PrimeRatePage = () => {
  const { _id } = useParams<any>();
  const defaultUpdate: Partial<PrimeRate> = { _id, active: true };
  const [update, setUpdate] = useState<Partial<PrimeRate>>(defaultUpdate);
  const documentRef = useRef<PrimeRate>(undefined);
  return <ModelFormPage
    modelClass={modelClass}
    styled={PrimeRatePageStyled}
    permission={(user) => user?.isSuperUser}
    documentRef={documentRef}
    defaultUpdate={defaultUpdate}
    update={update}
    setUpdate={setUpdate}
    formSpec={[
      [{ field: 'active', input: { type: Checkbox } }],
      [{ field: 'date', input: { type: DateInput } }, { field: 'rate', input: { type: NumberInput, props: { step: '0.01'} } }],
    ]}
  />;
};